<template>
  <div>
    <edg-navigation-sidebar
      class="navigation-bar"
      folded
      :selected-menu-item="selectedMenuItem"
      :menu-top="menuTop"
      :menu-middle="menuMiddle"
      :menu-bottom="menuBottom"
    >
      <div slot="title" class="d-flex align-items-center m-7">
        <div class="pl-2 title">{{ $t('navigation.title') }}</div>
        <div class="subtitle d-flex flex-column ml-2">
          <span>{{ $t('navigation.subtitle') }}</span>
        </div>
      </div>
    </edg-navigation-sidebar>
  </div>
</template>

<script>
import {EdgNavigationSidebar} from '@aedifica/ui-components'

import {parametrage} from '@/shared/parametrage'

export default {
  name: 'sad-navigation',
  components: {EdgNavigationSidebar},
  computed: {
    selectedMenuItem() {
      switch (this.$route.name) {
        case 'RechercheAutorisationConstruire':
          return 'autorisationConstruire'
        case 'RechercheVentesAppartements':
          return 'ventesAppartements'
        case 'RecherchePlanAffectation':
          return 'planAffectation'
        case 'RechercheDiversAmenagement':
          return 'diversAmenagement'
        case 'RechercheAvancee':
          return 'rechercheAvancee'
        case 'Rapports':
          return 'rapports'
        case '':
        case 'Home':
        default:
          return 'accueil'
      }
    },
    menuTop() {
      return [
        {
          id: 'accueil',
          libelle: 'Accueil',
          iconClass: 'fa-home',
          isSelected: false,
          isVisible: true,
          action: this.goToAccueil,
          ariaLabel: 'Accueil'
        }
      ]
    },
    menuMiddle() {
      return [
        {
          id: 'autorisationConstruire',
          libelle: this.$t('thematiques.autorisationConstruire'),
          iconClass: parametrage.thematiques.autorisationConstruire.icon,
          isSelected: false,
          isVisible: true,
          action: this.goToAutorisationConstruire,
          ariaLabel: this.$t('thematiques.autorisationConstruire')
        },
        {
          id: 'ventesAppartements',
          libelle: this.$t('thematiques.ventesAppartements'),
          iconClass: parametrage.thematiques.ventesAppartements.icon,
          isSelected: false,
          isVisible: true,
          action: this.goToVentesAppartements,
          ariaLabel: this.$t('thematiques.ventesAppartements')
        },
        {
          id: 'planAffectation',
          libelle: this.$t('thematiques.planAffectation'),
          iconClass: parametrage.thematiques.planAffectation.icon,
          isSelected: false,
          isVisible: true,
          action: this.goToPlanAffectation,
          ariaLabel: this.$t('thematiques.planAffectation')
        },
        {
          id: 'diversAmenagement',
          libelle: this.$t('thematiques.diversAmenagement'),
          iconClass: parametrage.thematiques.diversAmenagement.icon,
          isSelected: false,
          isVisible: true,
          action: this.goToDiversAmenagement,
          ariaLabel: this.$t('thematiques.diversAmenagement')
        },
        {
          id: 'rechercheAvancee',
          libelle: this.$t('thematiques.rechercheAvancee'),
          iconClass: parametrage.thematiques.rechercheAvancee.icon,
          isSelected: false,
          isVisible: true,
          action: this.goToRechercheAvancee,
          ariaLabel: this.$t('thematiques.rechercheAvancee')
        },
        {
          id: 'rapports',
          libelle: this.$t('thematiques.rapports'),
          iconClass: 'fas fa-chart-bar',
          isSelected: false,
          isVisible: true,
          action: this.goToRapports,
          ariaLabel: this.$t('thematiques.rapports')
        }
      ]
    },
    menuBottom() {
      return [
        {
          id: 'informations',
          libelle: this.$t('thematiques.informations'),
          iconClass: 'fas fa-info-circle',
          isSelected: false,
          isVisible: true,
          action: this.goToInformations,
          ariaLabel: this.$t('thematiques.informationsAriaLabel')
        }
      ]
    }
  },
  methods: {
    goToAccueil() {
      this.$router.push({name: 'Accueil'})
    },
    goToRapports() {
      this.$router.push({name: 'Rapports'})
    },
    goToRechercheAvancee() {
      this.$router.push({name: 'RechercheAvancee'})
    },
    goToAutorisationConstruire() {
      this.$router.push({name: 'RechercheAutorisationConstruire'})
    },
    goToVentesAppartements() {
      this.$router.push({name: 'RechercheVentesAppartements'})
    },
    goToPlanAffectation() {
      this.$router.push({name: 'RecherchePlanAffectation'})
    },
    goToDiversAmenagement() {
      this.$router.push({name: 'RechercheDiversAmenagement'})
    },
    goToInformations() {
      window.open('https://www.ge.ch/document/aide-plateforme-sad-consultation', '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@aedifica/ui-components/src/assets/scss/variables';

.navigation-bar {
  margin-top: 70px;
  padding-bottom: 30px;
  z-index: 1000;
}
.title {
  color: #fff;
  font-size: $font-size-h2;
}
.subtitle {
  color: lightgrey;
  font-size: 0.77rem;
}
</style>
